import React from "react";
import { Drawer, DrawerContent, DrawerHeader, DrawerTitle, DrawerDescription } from "../../ui/drawer";

export const InfoSheet = ({ open, onClose, title, description, children, testid }) => (
  <Drawer open={open} onOpenChange={(o) => !o && onClose()}>
    <DrawerContent className="max-h-[88vh]" data-testid={testid}>
      <div className="mx-auto w-full max-w-xl overflow-y-auto px-5 pb-8">
        <DrawerHeader className="px-0 text-left">
          <DrawerTitle className="text-[20px] font-extrabold text-[#2A0E4F]">{title}</DrawerTitle>
          {description && <DrawerDescription className="text-[14px] text-[#6F6585]">{description}</DrawerDescription>}
        </DrawerHeader>
        <div className="space-y-4 text-[15px] leading-relaxed text-[#3B2C55]">{children}</div>
        <button onClick={onClose} className="mt-6 w-full rounded-2xl bg-[#4C2380] py-3.5 text-[15px] font-bold text-white"
          data-testid={`${testid}-close`}>Entendi</button>
      </div>
    </DrawerContent>
  </Drawer>
);
